import React, { forwardRef, useContext } from 'react';
import { GrandsonContext } from '@flux/FluxRouter';

const WithAllPropsApp = WrappedComponent => {
  // Utiliza forwardRef para recibir la ref
  const WithAllProps = (props, ref) => {
    const grandsonProps = useContext(GrandsonContext);

    // Pasa tanto props como grandsonProps y ref al WrappedComponent
    return <WrappedComponent {...props} {...grandsonProps} ref={ref} />;
  };

  // Nombre para display en DevTools
  const componentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
  WithAllProps.displayName = `WithAllPropsApp(${componentName})`;

  // Retorna el componente envuelto con forwardRef
  return forwardRef(WithAllProps);
};

export default WithAllPropsApp;
